import type { ReactNode } from 'react';
import { trackClickedBanner } from 'search/analytics';
import { CorporateBanner as Corporate } from 'search/components/searchResults/ViinitieBanner/CorporateBanner';
import { WeddingBanner as Wedding } from 'search/components/searchResults/ViinitieBanner/WeddingBanner';
import { XmassBanner as Xmas } from 'search/components/searchResults/ViinitieBanner/XmassBanner';

const WEDDING = '33';
const MEETING = '41';
const EXHIBITION = '46';
const XMAS_PARTY = '60';

const CORPORATE_EVENT_TYPES = [MEETING, EXHIBITION];

type Props = { eventType: string };

export function ViinitieBanner(props: Props): ReactNode {
  if (CORPORATE_EVENT_TYPES.includes(props.eventType)) {
    return (
      <Corporate
        onClick={() => trackClickedBanner('Viinitie – Yritystilaisuudet')}
      />
    );
  } else if (props.eventType === XMAS_PARTY) {
    return (
      <Xmas onClick={() => trackClickedBanner('Viinitie – Pikkujoulut')} />
    );
  } else if (props.eventType === WEDDING) {
    return <Wedding onClick={() => trackClickedBanner('Viinitie – Häät')} />;
  } else {
    return null;
  }
}
